import React from 'react';
import PropTypes from 'prop-types';
import { WamNow } from 'app-modules/wamDialogs/containers/WamNow';
import { WamSoon } from 'app-modules/wamDialogs/containers/WamSoon';
import { OnboardDialog } from 'app-modules/wamDialogs/containers/OnboardDialog';
import { ChatNow } from 'app-modules/wamDialogs/containers/ChatNow';
import { ChatSoon } from 'app-modules/wamDialogs/containers/ChatSoon';

class WamDialogManager extends React.Component {
  // eslint-disable-next-line no-unused-vars
  componentDidUpdate(prevProps, prevState, snapshot) {
    const {
      isWamChannel,
      d0AlreadyDismissed,
      wamEpisodeStartsOnDate,
      nextWamStartsIn,
      nextChatEpisodeStartsIn,
    } = this.props;
    if (isWamChannel && !prevProps.isWamChannel && !d0AlreadyDismissed) {
      this.props.showOnboardDialog();
    }

    if (!isWamChannel && wamEpisodeStartsOnDate && nextWamStartsIn !== prevProps.nextWamStartsIn) {
      if (nextWamStartsIn >= 0 && nextWamStartsIn <= 1) {
        this.props.showWamNow();
      }
      if (nextWamStartsIn > 1 && nextWamStartsIn <= 10) {
        this.props.showWamSoon();
      }
    }

    if (nextChatEpisodeStartsIn !== prevProps.nextChatEpisodeStartsIn) {
      if (nextChatEpisodeStartsIn >= 0 && nextChatEpisodeStartsIn <= 1) {
        this.props.showChatNow();
      }
      if (nextChatEpisodeStartsIn > 1 && nextChatEpisodeStartsIn <= 10) {
        this.props.showChatSoon();
      }
    }
  }

  render() {
    return (
      <React.Fragment>
        <WamNow />
        <WamSoon />
        <OnboardDialog />
        <ChatNow />
        <ChatSoon />
      </React.Fragment>
    );
  }
}

WamDialogManager.propTypes = {
  isWamChannel: PropTypes.bool.isRequired,
  d0AlreadyDismissed: PropTypes.bool.isRequired,
  showOnboardDialog: PropTypes.func.isRequired,
  showWamNow: PropTypes.func.isRequired,
  showWamSoon: PropTypes.func.isRequired,
  wamEpisodeStartsOnDate: PropTypes.instanceOf(Date),
  nextWamStartsIn: PropTypes.number.isRequired,
  nextChatEpisodeStartsIn: PropTypes.number,
  showChatNow: PropTypes.func.isRequired,
  showChatSoon: PropTypes.func.isRequired,
};

WamDialogManager.defaultProps = {
  wamEpisodeStartsOnDate: null,
  nextChatEpisodeStartsIn: null,
};

export const WamDialogManagerComponent = WamDialogManager;
